import { z } from "../../wire/zod";

export const createAlmConnectionResponseSchema = z.object({ connectionId: z.string() });
export const getAlmConnectionsResponseSchema = z.object({
  connections: z.array(
    z.object({
      id: z.string().optional(),
      name: z.string().optional(),
      almType: z.string().optional(),
      almToolType: z.string().optional(),
      almName: z.string().optional(),
      state: z.string().describe("Connection health: 'error' or 'okay'").optional(),
    }),
  ),
});
export const getAlmToolsResponseSchema = z.object({
  almTools: z
    .record(z.string(), z.string())
    .describe("Map of alm_type -> human-readable tool name"),
});
export const getAlmTypeResponseSchema = z.object({ almType: z.string() });
export const getArtMappingSourcesResponseSchema = z.object({
  sources: z.array(z.record(z.string(), z.any())).describe("Field sources for a single ART"),
});
export const getCertificateInfoResponseSchema = z.object({
  certificateName: z.string(),
  notAfter: z.string(),
});
export const getDisableDeleteResponseSchema = z.object({ disableDelete: z.boolean() });
export const getIgnoreWebhooksFiredByAlmUserResponseSchema = z.object({
  ignoreWebhooksFiredByAlmUser: z.boolean(),
});
export const getNameResponseSchema = z.object({ name: z.string() });
export const getSessionInfoResponseSchema = z.object({
  syncSessionId: z.union([z.string(), z.null()]).optional(),
  almConnectionType: z.union([z.string(), z.null()]).optional(),
  almConnectionId: z.union([z.string(), z.null()]).optional(),
  disableDelete: z.boolean(),
});
export const getTeamMappingSourcesResponseSchema = z.object({
  sources: z.array(z.record(z.string(), z.any())).describe("Field sources for a single team"),
});
export const getTimeoutResponseSchema = z.object({
  timeout: z.number().int().describe("Timeout in seconds"),
});
export const getTlsVerificationResponseSchema = z.object({ tlsVerification: z.boolean() });
export const getUrlResponseSchema = z.object({ url: z.string() });
export const noDataSchema = z.record(z.string(), z.never());
